import type {
  ESignFormName,
  ESignStatusesMap,
  ESignStatusesResponse,
  PatientEncounter,
} from 'features/Procedure/state/procedure-api.type'

// Chip letters follow the tab order; Photos/Products get two letters to avoid the P clash.
export const ESIGN_CHIP_LETTERS: ReadonlyArray<readonly [ESignFormName, string]> = [
  ['encounter', 'E'],
  ['photo', 'Ph'],
  ['soap_r', 'N'],
  ['product', 'Pr'],
  ['labs', 'L'],
]

export const ESIGN_CHIP_SEPARATOR = '|'

export const normalizeESignStatuses = (
  statuses: ESignStatusesResponse | null | undefined,
): ESignStatusesMap => {
  if (!statuses || Array.isArray(statuses)) return {}
  return statuses
}

export const getESignChipLabel = (
  statuses: ESignStatusesResponse | null | undefined,
): string | null => {
  const statusesMap = normalizeESignStatuses(statuses)
  const letters = ESIGN_CHIP_LETTERS.filter(([formName]) => statusesMap[formName] === 1).map(
    ([, letter]) => letter,
  )
  return letters.length > 0 ? letters.join(ESIGN_CHIP_SEPARATOR) : null
}

export const resolveLatestEncounterWithUuid = (
  encounters: PatientEncounter[],
): PatientEncounter | null => {
  return encounters.find((encounter) => Boolean(encounter.encounter_uuid)) ?? null
}
